import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Checkbox } from "antd";
import { IColumnMetadata } from "~/app/dashboard/components/ObjectViews/types";

import { cn } from "~/core/generic/shadcn-utils";
import { CommandItem } from "~/core/ui/Command";
import If from "~/core/ui/If";

import ColumnIcon from "~/components/DataTableCells/ColumnIcon";

import { faCheck } from "@fortawesome/pro-regular-svg-icons";

import { DDRendererItem } from "../../types";

interface DDRendererCommandListItemProps {
  item: DDRendererItem;
  isSelected: boolean;
  isMultiSelect?: boolean;
  onSelect: (item: DDRendererItem) => void;
  onMultiSelect?: (item: DDRendererItem) => void;
}

export const DDRendererCommandListItem = ({
  item,
  isSelected,
  isMultiSelect,
  onSelect,
  onMultiSelect,
}: DDRendererCommandListItemProps) => {
  const columnMetadata = item.metadata as IColumnMetadata;

  return (
    <CommandItem
      className={cn("cursor-pointer flex items-center justify-between", {
        "bg-light": isSelected,
        "hover:bg-light": true,
      })}
      key={item.id}
      role="option"
      onSelect={() => onSelect(item)}
      value={String(item.id)}
    >
      <div
        className={cn(
          "max-w-[calc(100%_-_32px)] truncate flex gap-2 items-center",
          {
            "max-w-full": !item.active,
          },
        )}
      >
        <If condition={isMultiSelect}>
          <Checkbox
            onClick={e => {
              e.stopPropagation();
            }}
            checked={item.active}
            onChange={() => {
              onMultiSelect?.(item);
            }}
          />
        </If>
        <If condition={columnMetadata?.attribute_type}>
          <ColumnIcon
            attributeType={columnMetadata?.attribute_type}
            entityType={columnMetadata?.entity_type}
            field={columnMetadata?.field}
          />
        </If>
        {item.label}
      </div>
      <If condition={item.active && !isMultiSelect}>
        <FontAwesomeIcon icon={faCheck} className="size-3 text-light" />
      </If>
    </CommandItem>
  );
};
